import React from 'react';
import {Routes, BrowserRouter, Route, Navigate} from 'react-router-dom'
import {useSelector} from 'react-redux';
import PrivateRouteContainer from "./PrivateRoute/PrivateRouteContainer";
import PublicRouteContainer from "./PublicRoute/PublicRouteContainer";
import AppContainer from "./App/AppContainer";
import LoginContainer from "./Login/LoginContainer";
import Maintenance from "./Maintenance/Maintenance";
import {getMaintenance} from '../../redux/selectors/ui/ui.selectors';

const Router = () => {
    const maintenance = useSelector(getMaintenance);

    return (
        <BrowserRouter>
            <Routes>
                <Route path={'/maintenance'} element={<Maintenance />} />

                {maintenance && (
                    <Route path={'*'} element={<Navigate to={'/maintenance'} replace />} />
                )}

                {/* Routes publiques (redirigent vers / si déjà connecté) */}
                <Route element={<PublicRouteContainer />}>
                    <Route path={'/connexion'} element={<LoginContainer />} />
                    <Route path={'/login'} element={<LoginContainer />} />
                    <Route path={'/forgot-password'} element={<LoginContainer />} />
                    <Route path={'/reset-password'} element={<LoginContainer />} />
                </Route>

                {/* Routes privées */}
                <Route path={'*'} element={
                    <PrivateRouteContainer>
                        <AppContainer />
                    </PrivateRouteContainer>
                } />
            </Routes>
        </BrowserRouter>
    );
};

export default Router;
